import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
} from "react";
import { ENDPOINTS } from "../../common/utils/Constants";
import { doGET, doPOST } from "../../util/HttpUtil";
import {
  clearAuthResume,
  clearAuthTokens,
  clearStoredAuthMessage,
  clearVerifyIndividualContext,
  markExplicitLogoutLanding,
  persistAuthTokens,
  setLegacyUnauthUrl,
} from "../../util/authResume";
import { ApiHandler } from "../apiHandler/apiHandler";
import { useSearchParams } from 'react-router-dom'; // Assuming you're using React Router v6

export const UserContext = React.createContext();

export const UserProvider = (props) => {
  const [allProfiles] = useState(null);
  const [userContent, setUserContent] = useState(null);
  const [currentPageName, setCurrentPageName] = useState("");
  const [forSuperadmin, setForSuperadmin] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const populateUserContent = useCallback(async () => {
    const searchParams = new URLSearchParams(window.location.search);
    const authorizationToken = searchParams.get('Authorization');

    // Broker admins authenticate into a separate scope (token allows only
    // /api/broker/*). They must NOT hit the general /api/profile endpoint —
    // doing so returns 401 and forces a logout/redirect on every load. The
    // broker portal sources its identity from the stored BrokerProfile.
    let brokerProfile = null;
    try {
      brokerProfile = JSON.parse(localStorage.getItem("BrokerProfile") || "null");
    } catch (err) {
      brokerProfile = null;
    }
    const isBrokerSession = brokerProfile?.role === "broker_admin";

    if (localStorage.getItem("BearerToken") && !authorizationToken) {
      if (isBrokerSession) {
        setUserContent(brokerProfile);
        setIsLoggedIn(true);
        return;
      }
      try {
        const response = await doGET(ENDPOINTS.userContent);
        if (response.status === 200 && response.data !== userContent) {
          const content = response.data?.[0]?.userContent
          setUserContent(content);
          setIsLoggedIn(true);
        }
      } catch (err) {
        console.log(err);
      }
    } else {
      setIsLoggedIn(false);
    }
  }, []);


  useEffect(() => {
    populateUserContent();

  }, [populateUserContent])







  const isAdmin = () => {
    return userContent?.isAdmin ? true : false;
  }

  const eddLogin = async (loginData) => {
    try {
      const response = await doPOST(ENDPOINTS.eddLogin, loginData);
      if (response?.data?.action) {
        persistAuthTokens({ bearerToken: response.data.bearerToken });
        return "choose-profile";
      }

      if (response.status === 200) {
        persistAuthTokens({
          bearerToken: response.data.bearerToken,
          refreshToken: response.data.refreshToken,
          expiry: response.data.expiry,
          activeApplicationId: response.data?.userContent?.application_id || response.data?.userContent?._id || "",
        });
        await populateUserContent();
      }
      return response;
    } catch (err) {
      setIsLoggedIn(false);
      console.log(err);
      return err;
    }
  };

  const login = async (data) => {
    try {
      const response = await doPOST(ENDPOINTS.login, data);
      if (response?.data?.action) {
        persistAuthTokens({ bearerToken: response.data.bearerToken });
        return "choose-profile";
      }

      if (response.status === 200) {
        persistAuthTokens({
          bearerToken: response.data.bearerToken,
          refreshToken: response.data.refreshToken,
          expiry: response.data.expiry,
          activeApplicationId: response.data?.userContent?.application_id || response.data?.userContent?._id || "",
        });
        await populateUserContent();
      }
      return response;
    } catch (err) {
      setIsLoggedIn(false);
      console.log(err);
      return err
    }
  };

  const switchProfile = async (index) => {
    try {
      // setLoading(true)
      if (index > -1 && index < allProfiles?.length) {
        const reqBody = {
          reqParam: {}, method: "GET", endPoint: "/auth/refresh-token",
          token: allProfiles[index]?.refreshToken
        };
        const newBearerTokenResponse = await ApiHandler(reqBody);

        if (newBearerTokenResponse?.status === 200) {
          persistAuthTokens({
            bearerToken: newBearerTokenResponse.data?.bearerToken,
            refreshToken: allProfiles[index]?.refreshToken,
            expiry: newBearerTokenResponse.data.expiry,
            activeApplicationId:
              allProfiles[index]?.userContent?.application_id ||
              allProfiles[index]?.userContent?._id ||
              "",
          });
          window.location.reload();
        }
        // setUser(allProfiles[index]?.userContent);
      }
    } catch (error) {

    }
    // setLoading(false)
  };


  const logout = async () => {
    try {
      await doPOST(ENDPOINTS.logout);
    } catch (err) {
      console.log(err);
    }
    clearAuthTokens();
    clearAuthResume();
    clearStoredAuthMessage();
    clearVerifyIndividualContext();
    setLegacyUnauthUrl("");
    markExplicitLogoutLanding();
    setUserContent(null);
    setIsLoggedIn(false);
    window.location = "/";
  };

  return (
    <UserContext.Provider
      value={{
        userContent,
        populateUserContent,
        login,
        logout,
        isLoggedIn,
        isAdmin,
        switchProfile,
        allProfiles,
        forSuperadmin,
        setForSuperadmin,
        currentPageName,
        eddLogin,
        setCurrentPageName
      }}
    >
      {props?.children}
    </UserContext.Provider>
  );
};
